import React from "react";
import YearAmount from "../../basics/YearAmount";
import FeeDetail from "./FeeDetail";
import ClosingHeader from "./ClosingHeader";
import Loader from "../../../Loader";
import Apply from "./Apply";
import TotalClosingCosts from "./TotalClosingCosts";
import { AutomationPlacement } from "../../../../utilities/automation"
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

export interface IDummyFeeProps {
    show: boolean,
    emailValues: any,
    spinner: boolean,
    loanName: string,
    loanLabel?: string,
    referrerId?: string
}

export default (props: IDummyFeeProps) => {
    const { show, spinner, loanName, loanLabel, referrerId } = props;
    const { lang } = useLanguage();

    if (!show) {
        const closingHeaderProps = {
            className: "col-12 px-3 pt-3 pb-0",
            headerText: loanName,
            label: loanLabel,
            subHeaderClassName: "small"
        };

        const yearAmountProps = {
            monthlyRate: 0,
            apr: 0,
            initialRate: 0,
            className: "h-90 pt-4",
            percentageClassName: "text-serif mt-3 text-muted",
            perMonthClassName: "",
            amountLargeFontSize: 42,
            percentFontSize: 18,
            location: AutomationPlacement.MODAL,
            paymentCount: 360
        };
        return (
            <div className="m-2 mb-5 p-4 text-gainsboro">
                <Loader spinner={spinner} />
                <ClosingHeader {...closingHeaderProps} />
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-12 pb-0 border-md-border-0 border-bottom-0 border-lg-right text-gainsboro">
                        <YearAmount {...yearAmountProps} />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 pl-3 pt-3 pb-0 border-md-border-0 border-bottom-0 border-lg-right">
                        <FeeDetail label={getTranslation(lang).principalAndInterest} feeClassName="p-0 font-weight-bold text-right" labelClassName="font-weight-bold" fee={0} />
                        <FeeDetail label={getTranslation(lang).taxes} feeClassName="p-0 font-weight-bold text-right" labelClassName="font-weight-bold" fee={0} />
                        <FeeDetail label={getTranslation(lang).insurance} feeClassName="p-0 font-weight-bold text-right" labelClassName="font-weight-bold" fee={0} />
                    </div>
                    <Apply disabled={true} referrerId={referrerId} />
                </div>
                <TotalClosingCosts totalClosingCost={0} />
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-12 px-3 pt-3 pb-0 border-lg-right">
                        <FeeDetail feeClassName="text-right m-0 p-0" labelClassName="font-weight-bold" label={getTranslation(lang).lenderFees} fee={""} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).loanOriginationFee} fee={0} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).processingFee} fee={0} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).mortgagePoints} fee={0} />
                        <FeeDetail labelClassName="p-0 text-right" feeClassName="text-right border border-gainsboro border-left-0 border-right-0 border-bottom-0 pt-1 mt-2 p-0" label="" fee={0} />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 px-3 pt-3 pb-0 border-lg-right">
                        <FeeDetail feeClassName="text-right m-0 p-0" labelClassName="font-weight-bold" label={getTranslation(lang).creditReportFee} fee={""} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).creditReportFee} fee={0} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).titleFees} fee={0} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).appraisal} fee={0} />
                        <FeeDetail feeClassName="p-0 text-right" label={getTranslation(lang).constructionInspectionFees} fee={0} />
                        <FeeDetail feeClassName="text-right border border-gainsboro border-left-0 border-right-0 border-bottom-0 pt-1 mt-2 p-0" label="" fee={0} />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 px-3 pt-3 pb-0">
                        <FeeDetail feeClassName="text-right m-0 p-0" labelClassName="font-weight-bold" label={getTranslation(lang).itemsDueAtClosing} fee={""} />
                        <FeeDetail feeClassName="text-right m-0 p-0" label={getTranslation(lang).interestPartialMonth} fee={"TBD"} />
                        <FeeDetail feeClassName="text-right m-0 p-0" label={getTranslation(lang).homeOwnersInsurance} fee={"TBD"} />
                        <FeeDetail feeClassName="text-right m-0 p-0" label={getTranslation(lang).propertyTaxes} fee={"TBD"} />
                        <FeeDetail feeClassName="text-right border border-gainsboro border-left-0 border-right-0 border-bottom-0 p-0 pt-1 mt-2" label="" fee={"TBD"} />
                    </div>
                </div>
            </div>
        );
    }
    return null;

};